/** @format */

import React from 'react';
import config from 'config';
import { Link, useHistory } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import Dropdown from 'react-bootstrap/Dropdown';
import { NAV_KEYS } from '../common';
import { QALocalEnvOnly } from 'utils';

import './styles.scss';

const { brokerLoginUrl } = config.app;

const Header = ({
  buttonText,
  homepageUrl = '/',
  show,
  setShow,
  // setDisplayContactSeller,
  t
}) => {
  const router = useHistory();
  // const location = useLocation();

  const Logo = () => (
    <Link to={homepageUrl} className='logo'>
      <div className='logo-fria-maklare-dark' />
    </Link>
  );

  const NavLinksBar = () => {
    const NavElement = ({ activeClass, onClick, label }) => (
      <span className={activeClass} onClick={onClick}>
        {label}
      </span>
    );

    const NavLink = ({ label, to = null }) => {
      // if ([NAV_KEYS.SELL, NAV_KEYS.BUY, NAV_KEYS.APPRAISE].includes(navKey)) {
      //   // show leads popup

      //   return (
      //     <NavElement
      //       label={label}
      //       onClick={() => {
      //         setDisplayContactSeller(true);
      //       }}
      //     />
      //   );
      // } else {
      //   // redirect
      //   // const activeClass = location?.pathname === `/${to}` ? 'active' : '';

      // }

      const redirectionHandler = () => {
        if (to) {
          router.push(to);
        }
      };

      return (
        <NavElement
          activeClass={false}
          label={label}
          onClick={() => redirectionHandler()}
        />
      );
    };

    const ServicesDropdown = () => (
      <Dropdown>
        <Dropdown.Toggle variant='light'>
          {t('lang_header:services:button:text')}
        </Dropdown.Toggle>
        <Dropdown.Menu>
          <QALocalEnvOnly>
            <Dropdown.Item>
              <NavLink
                label={t('lang_header:build_property:button:text')}
                to={t(`lang_route:registration_build_property_page`)}
                navKey={NAV_KEYS.BUILD_PROPERTY}
              />
            </Dropdown.Item>
          </QALocalEnvOnly>

          <Dropdown.Item>
            <NavLink
              label={t('lang_header:invest:button:text')}
              to={t(`lang_route:registration_invest_page`)}
              navKey={NAV_KEYS.INVEST}
            />
          </Dropdown.Item>

          <Dropdown.Item>
            <NavLink
              label={t('lang_header:monitor:button:text')}
              to={t(`lang_route:registration_monitor_page`)}
              navKey={NAV_KEYS.MONITOR}
            />
          </Dropdown.Item>

          <Dropdown.Item>
            <NavLink
              label={t('lang_header:renovate:button:text')}
              to={t(`lang_route:registration_renovate_page`)}
              navKey={NAV_KEYS.RENOVATE}
            />
          </Dropdown.Item>
          <Dropdown.Item>
            <NavLink
              label={t('lang_header:visningsklar:button:text')}
              to={t(`lang_route:leads_visningsklar_page`)}
              navKey={NAV_KEYS.VISNINGSKLAR}
            />
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    );

    return (
      <div className='header-nav-links'>
        <NavLink
          label={t('lang_header:sell:button:text')}
          to={t(`lang_route:leads_sell_page`)}
          navKey={NAV_KEYS.SELL}
        />
        <NavLink
          label={t('lang_header:appraise:button:text')}
          navKey={NAV_KEYS.APPRAISE}
          to={t(`lang_route:leads_evaluate_page`)}
        />
        <NavLink
          label={t('lang_header:buy:button:text')}
          to={t('lang_route:leads_buy_page')}
          navKey={NAV_KEYS.BUY}
        />
        <NavLink
          label={t('lang_header:abroad:button:text')}
          to='/abroad'
          navKey={NAV_KEYS.ABROAD}
        />
        <NavLink
          label={t('lang_header:for_sale:label')}
          to={t(`lang_route:search`)}
          navKey={NAV_KEYS.FOR_SALE}
        />

        <ServicesDropdown />
      </div>
    );
  };

  const ButtonsSection = () => {
    return (
      <div className='header-buttons-section'>
        <Button
          onClick={() => {
            window.location.href = brokerLoginUrl;
          }}
          className='btn btn-white btn btn-primary'
          style={{
            marginRight: '10px'
          }}>
          {buttonText[0]?.text}
        </Button>
        <Button
          onClick={() => router.push('registrera')}
          className='btn btn-pink btn btn-primary'>
          {buttonText[1]?.text}
        </Button>
      </div>
    );
  };

  return (
    <>
      <div className='header-v2'>
        <div className='absolute-header-cover' />
        <div className='header-left-container'>
          <Logo />
          <div
            className={`hamburger-menu-icon-block ${show ? 'show' : 'hide'}`}
            onClick={() => setShow(!show)}
          />
        </div>
        <div className='header-middle-container'>
          <NavLinksBar />
        </div>
        <div className='header-right-container'>
          <ButtonsSection />
        </div>
      </div>
    </>
  );
};

export default Header;
